import { Pipe, PipeTransform } from '@angular/core';
import { Mxstoplimit } from '@app/models/mxstoplimit';

@Pipe({
  name: 'stoplimitType'
})
export class StoplimitTypePipe implements PipeTransform {

  transform(orderType: String): string {

    let transType: string = "";

    if (orderType === "1") {
      transType = "Limit Order";
    } else if (orderType === "2") {
      transType = "Stop Limit Order";
    } else if (orderType === "3") {
      transType = "Repurchase Order";
    } else {
      transType = "No description is available.";
    }
    return transType;
  }

}
